import { render } from "./GravatarImage.vue?vue&type=template&id=976377a8"
import script from "./GravatarImage.vue?vue&type=script&lang=js"
export * from "./GravatarImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__